import { c as _c } from "react/compiler-runtime";
import { Popover, Tag, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { DecryptOption } from '@/components/roles';
import useMobileLayout from '@/hooks/use-mobile-layout';
export type DecryptOptionProps = {
  options: DecryptOption[];
  label?: string;
  as?: React.ElementType;
};
const SLICE_SIZE = 1;
const DecryptOptions = t0 => {
  const $ = _c(46);
  const {
    options,
    label
  } = t0;
  const {
    t
  } = useTranslation("roles");
  const isMobile = useMobileLayout();
  let t1;
  if ($[0] !== label || $[1] !== t) {
    t1 = label ?? t(_temp);
    $[0] = label;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const decryptLabel = t1;
  let RemainingOptions;
  let T0;
  let remainingOptions;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[3] !== decryptLabel || $[4] !== isMobile || $[5] !== options || $[6] !== t) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const translations = {
        all: t(_temp2),
        all_except_pci_data: t(_temp3),
        name: t(_temp4),
        email: t(_temp5),
        phone_number: t(_temp6),
        us_tax_id: t(_temp7),
        ssn4: t(_temp8),
        dob: t(_temp9),
        documents: t(_temp10),
        documents_and_selfie: t(_temp11),
        full_address: t(_temp12),
        custom: t(_temp13),
        us_legal_status: t(_temp14),
        investor_profile: t(_temp15),
        card: t(_temp16),
        decrypt_document_and_selfie: t(_temp17),
        decrypt_document: t(_temp18),
        business_name: t(_temp19),
        business_corporation_type: t(_temp20),
        business_tin: t(_temp21),
        business_website: t(_temp22),
        business_phone_number: t(_temp23),
        business_address: t(_temp24),
        business_kyced_beneficial_owners: t(_temp25),
        business_formation_info: t(_temp26)
      };
      if (options.length === 0) {
        t7 = null;
        break bb0;
      }
      const translatedOptions = options.map(scope => translations[scope as keyof typeof translations] || scope);
      if (options.length <= SLICE_SIZE) {
        const t8 = <span className="flex gap-1">{decryptLabel}:<span className="flex">{translatedOptions.join(", ")}</span></span>;
        let t9;
        if ($[16] !== t8) {
          t9 = <Tag>{t8}</Tag>;
          $[16] = t8;
          $[17] = t9;
        } else {
          t9 = $[17];
        }
        t7 = t9;
        break bb0;
      }
      const firstTwoOptions = translatedOptions.slice(0, SLICE_SIZE);
      remainingOptions = translatedOptions.slice(SLICE_SIZE);
      RemainingOptions = _temp28;
      if (isMobile) {
        const t8 = <div className="max-w-[calc(100vw-32px)] p-3 text-body-2 text-primary"><RemainingOptions remainingOptions={remainingOptions} /></div>;
        let t9;
        if ($[18] !== remainingOptions) {
          t9 = <button type="button" className="ml-1 underline underline-offset-2 text-primary">and {remainingOptions.length} more</button>;
          $[18] = remainingOptions;
          $[19] = t9;
        } else {
          t9 = $[19];
        }
        let t10;
        if ($[20] !== t8 || $[21] !== t9) {
          t10 = <Popover align="center" side="bottom" content={t8}>{t9}</Popover>;
          $[20] = t8;
          $[21] = t9;
          $[22] = t10;
        } else {
          t10 = $[22];
        }
        const t11 = <span className="flex gap-1">{decryptLabel}:<span className="flex">{firstTwoOptions.join(", ")}{t10}</span></span>;
        let t12;
        if ($[23] !== t11) {
          t12 = <Tag>{t11}</Tag>;
          $[23] = t11;
          $[24] = t12;
        } else {
          t12 = $[24];
        }
        t7 = t12;
        break bb0;
      }
      T0 = Tag;
      t4 = "flex gap-1";
      t5 = decryptLabel;
      t6 = ":";
      t2 = "flex";
      t3 = firstTwoOptions.join(", ");
    }
    $[3] = decryptLabel;
    $[4] = isMobile;
    $[5] = options;
    $[6] = t;
    $[7] = RemainingOptions;
    $[8] = T0;
    $[9] = remainingOptions;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    RemainingOptions = $[7];
    T0 = $[8];
    remainingOptions = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  const t8 = !remainingOptions.length;
  let t9;
  if ($[25] !== RemainingOptions || $[26] !== remainingOptions) {
    t9 = <RemainingOptions remainingOptions={remainingOptions} />;
    $[25] = RemainingOptions;
    $[26] = remainingOptions;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== remainingOptions.length) {
    t10 = <span className="ml-1 underline underline-offset-2 text-primary">and {remainingOptions.length} more</span>;
    $[28] = remainingOptions.length;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t8 || $[32] !== t9) {
    t11 = <Tooltip disabled={t8} content={t9}>{t10}</Tooltip>;
    $[30] = t10;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t2 || $[36] !== t3) {
    t12 = <span className={t2}>{t3}{t11}</span>;
    $[34] = t11;
    $[35] = t2;
    $[36] = t3;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t12 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6) {
    t13 = <span className={t4}>{t5}{t6}{t12}</span>;
    $[38] = t12;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== T0 || $[44] !== t13) {
    t14 = <T0>{t13}</T0>;
    $[43] = T0;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
};
export default DecryptOptions;
function _temp($) {
  return $.scopes.decrypt_fields_one;
}
function _temp2($_0) {
  return $_0.scopes.decrypt.all;
}
function _temp3($_1) {
  return $_1.scopes.decrypt_all_except_pci_data;
}
function _temp4($_2) {
  return $_2.scopes.decrypt.name;
}
function _temp5($_3) {
  return $_3.scopes.decrypt.email;
}
function _temp6($_4) {
  return $_4.scopes.decrypt.phone_number;
}
function _temp7($_5) {
  return $_5.scopes.decrypt.us_tax_id;
}
function _temp8($_6) {
  return $_6.scopes.decrypt.ssn4;
}
function _temp9($_7) {
  return $_7.scopes.decrypt.dob;
}
function _temp10($_8) {
  return $_8.scopes.decrypt.documents;
}
function _temp11($_9) {
  return $_9.scopes.decrypt.documents_and_selfie;
}
function _temp12($_10) {
  return $_10.scopes.decrypt.full_address;
}
function _temp13($_11) {
  return $_11.scopes.decrypt.custom;
}
function _temp14($_12) {
  return $_12.scopes.decrypt.us_legal_status;
}
function _temp15($_13) {
  return $_13.scopes.decrypt.investor_profile;
}
function _temp16($_14) {
  return $_14.scopes.decrypt.card;
}
function _temp17($_15) {
  return $_15.scopes.decrypt.decrypt_document_and_selfie;
}
function _temp18($_16) {
  return $_16.scopes.decrypt.decrypt_document;
}
function _temp19($_17) {
  return $_17.scopes.decrypt.business_name;
}
function _temp20($_18) {
  return $_18.scopes.decrypt.business_corporation_type;
}
function _temp21($_19) {
  return $_19.scopes.decrypt.business_tin;
}
function _temp22($_20) {
  return $_20.scopes.decrypt.business_website;
}
function _temp23($_21) {
  return $_21.scopes.decrypt.business_phone_number;
}
function _temp24($_22) {
  return $_22.scopes.decrypt.business_address;
}
function _temp25($_23) {
  return $_23.scopes.decrypt.business_kyced_beneficial_owners;
}
function _temp26($_24) {
  return $_24.scopes.decrypt.business_formation_info;
}
function _temp27(option) {
  return <li key={option}>{option}</li>;
}
function _temp28(t0) {
  const {
    remainingOptions: remainingOptions_0
  } = t0;
  return <ul className="flex flex-col list-disc list-inside py-0.5">{remainingOptions_0.map(_temp27)}</ul>;
}